import { Spacing } from '@persona-id/design-tokens';
import { EyeIcon, EyeOffIcon } from '@persona-id/design-tokens/icons';
import { Fragment, useState } from 'react';
import { UseFieldArrayAppend, UseFieldArrayRemove } from 'react-hook-form';
import styled from 'styled-components';

import HoverableDraggable from 'dashboard/components/FormControls/GraphNodeConfigurationRow/HoverableDraggable';
import { GraphNodeConfigFormData } from 'dashboard/forms/FormGraphNodeConfiguration/FormGraphNodeConfiguration';
import { GraphAttributes } from 'dashboard/models/graph';
import { GraphProperty } from 'dashboard/models/graph/node-render-config';

type GraphNodePropertyRowProps = {
  graphProperty: GraphProperty;
  index: number;
  toggleVisibility?: () => void;
  dimmed: boolean;
  remove: UseFieldArrayRemove;
  append: UseFieldArrayAppend<GraphAttributes> | UseFieldArrayAppend<GraphNodeConfigFormData>;
  onGraphConfigEdit: () => void;
  isCustomNode: boolean;
};

const ItemContainer = styled.section`
  flex: 1;
  display: flex;
`;
const LabelContainer = styled('span')`
  text-overflow: ellipsis;
  max-width: 265px;
  overflow: hidden;
  margin-left: 6px;
`;

const IconButtonContainer = styled('div')`
  padding-right: 9px;
  min-width: ${Spacing[2]};
  margin-left: auto;
  margin-right: 0;
  display: inline-block;
  cursor: pointer;
  svg {
    vertical-align: text-top;
  }
`;

const StyledEyeIcon = styled(EyeIcon)<{ hover: boolean }>`
  visibility: ${(props) => (props.hover ? 'visible' : 'hidden')};
`;

export const GraphNodePropertyRow = ({
  graphProperty,
  index,
  dimmed,
  remove,
  append,
  onGraphConfigEdit,
  isCustomNode,
}: GraphNodePropertyRowProps) => {
  const [hover, setHover] = useState(false);

  const handleToggleClick = () => {
    if (dimmed) {
      append(graphProperty);
    } else {
      remove(index);
    }
    onGraphConfigEdit();
  };

  return (
    <Fragment key={index}>
      <HoverableDraggable draggableId={index.toString()} index={index} isDragDisabled={dimmed}>
        <ItemContainer
          onMouseEnter={(e) => {
            e.stopPropagation();
            setHover(true);
          }}
          onMouseLeave={(e) => {
            e.stopPropagation();
            setHover(false);
          }}
        >
          <LabelContainer>{graphProperty.value}</LabelContainer>
          {!isCustomNode && (
            <IconButtonContainer
              role='button'
              id='label'
              onClick={(e) => {
                handleToggleClick();
                e.stopPropagation();
              }}
            >
              {dimmed && <EyeOffIcon />}
              {!dimmed && <StyledEyeIcon hover={hover} />}
            </IconButtonContainer>
          )}
        </ItemContainer>
      </HoverableDraggable>
    </Fragment>
  );
};
